import { T } from '@tribeplatform/react-components/i18n'
import { useSlate } from '@tribeplatform/react-slate-kit/hooks'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip'

export const EmptyState = ({ title }) => {
  const { mode } = useSlate()

  if (mode !== 'live') {
    return (
      <Card>
        <Card.Header
          title={title}
          size="sm"
          action={
            <Tooltip>
              <Tooltip.Trigger>
                <SvgIcon
                  className="text-content-subdued w-4 h-4"
                  name="eye-off"
                />
              </Tooltip.Trigger>
              <Tooltip.Panel>
                <T
                  defaultMessage="There’s nothing to show here, so it’s automatically hidden from {MEMBERS}."
                  id="TagsBlock.EmptyState.NothingToShow"
                />
              </Tooltip.Panel>
            </Tooltip>
          }
        />
        <Card.Content>
          <div className="text-sm text-content-subdued">
            <T
              defaultMessage="Assign {TAGS} to posts, and a list of {TAGS} will show here"
              id="TagsBlock.EmptyState.Hint"
            />
          </div>
        </Card.Content>
      </Card>
    )
  }

  // hide empty block from regular users
  return null
}
